//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'MessagesTextTabs',

    computed: {
        filters() {
            return this.$store.getters['conversations/getFilters'];
        },

        textTabItems() {
            return [
                {
                    text: 'All',
                    name: 'all',
                    active: this.$route.params.name === 'all',
                },
                {
                    text: 'Active',
                    name: 'active',
                    active: this.$route.params.name === 'active',
                },
                {
                    text: 'Inactive',
                    name: 'inactive',
                    active: this.$route.params.name === 'inactive',
                },
                {
                    text: 'Head Hunted Candidates',
                    name: 'head-hunted-candidates',
                    active: this.$route.params.name === 'head-hunted-candidates',
                },
                {
                    text: 'Job Invites',
                    name: 'job-invites',
                    active: this.$route.params.name === 'job-invites',
                },
                {
                    text: 'Archived',
                    name: 'archived',
                    active: this.$route.params.name === 'archived',
                },
            ];
        },
    },

    created() {
        this.setFilters();
    },

    watch: {
        /*
         * Update the filters and get the conversations when a tab is opened in the
         * messages section. Do not set the filters and get the candidates when
         * a specific conversation is not selected.
         */
        $route() {
            if (this.$route.params.id) return;

            this.setFilters();
        },
    },

    methods: {
        async setFilters() {
            const filters =
                {
                    active: { active: '1' },
                    inactive: { active: '0' },
                    archived: { archived: '1' },
                    'head-hunted-candidates': { head_hunted: '1' },
                    'job-invites': { job_invites: '1' },
                }[this.$route.params.name] || null;

            await this.$store.dispatch('conversations/setSearch', null);

            await this.$store.dispatch('conversations/setFilters', filters);

            await this.$store.dispatch('conversations/getConversations');
        },
    },
};
